var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"diploma-item"},[_c('img',{attrs:{"src":require(`@/assets/images/school_logos/${_vm.diploma.schoolLogoName}`),"alt":"school logo"}}),_c('h3',[_vm._v(_vm._s(_vm.diploma.name))]),_c('i',[_c('h4',[_vm._v(_vm._s(_vm.diploma.accolade))])]),_c('h4',[_vm._v(_vm._s(_vm.diploma.graduationDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }